import React, { useEffect, useState, useRef } from "react";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from "aos"; // Import AOS library
import { PartenerSheepDeedService } from "../services/parternshipservice";
import Footer from "./footer";
import ServicesTabs from "./Servicestabs";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { gsap } from 'gsap';
import CountUp from "react-countup";
import { BrowserRouter, Route, Router, Link, Routes } from 'react-router-dom';
import HomeCounters from "./Homecounters";







const Type = (words, elementId) => {
   const htmlDom = document.getElementById(elementId);
   const delay = (time) => new Promise((resolve) => setTimeout(resolve, time));

   const eraser = async () => {
      const originalText = htmlDom.innerText;
      for (let i = originalText.length; i > 0; i--) {
         await delay(40); // Speed for erasing
         htmlDom.innerText = originalText.slice(0, i - 1);
      }
   };

   const blinking = async (times) => {
      for (let i = 0; i < times; i++) {
         await delay(400); // Blinking delay
         htmlDom.innerText = htmlDom.innerText.endsWith("")
            ? htmlDom.innerText.slice(0, -1)
            : htmlDom.innerText + ""; // Adding blinking cursor
      }
   };

   const writer = async (word) => {
      const wordArray = word.split("");
      for (const char of wordArray) {
         await delay(50); // Typing speed
         htmlDom.innerText += char;
      }
      await blinking(3); // Blink after writing
      await eraser(); // Erase after blinking
   };

   const loop = async () => {
      while (true) {
         for (const word of words) {
            await writer(word);
         }
      }
   };

   loop();
};

function Content() {

   const listRef = useRef(null);

   useEffect(() => {
      const slides = listRef.current.children;
      const duration = 6;
      const lineHeight = 50;

      const timeline = gsap.timeline({ repeat: -1 });

      Array.from(slides).forEach((_, i) => {
         timeline.to(listRef.current, {
            duration: duration / slides.length,
            y: i * -1 * lineHeight,
            ease: 'elastic.out(1, 0.4)',
         });
      });

      timeline.play();
   }, []);
   useEffect(() => {
      AOS.init({
         duration: 1000, // Animation duration
         once: true, // Whether animation should happen only once
      });
   }, []);


   useEffect(() => {
      AOS.init({ duration: 1000, once: true }); // Initialize AOS
      Type(
         [
            "Business Need...",
            "Business Growth...",
            "MSME Registration...",
            "Gumasta License...",
            "Trade Mark Registration...",
            "GST Registration...",
            "Food Licence...",
            "Online Accounting...",
            "GST Return Filing...",
            "ITR Filing...",
         ],
         "typing-effect"
      );


   }, []); // The empty array ensures this runs only once when the component is mounted


   const [newData, setNewData] = useState({ user_firstname: '', user_emailaddress: '', user_contact_us: '', user_message: '' })

   const [errors, setErrors] = useState({});

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_firstname.trim()) {
         newErrors.user_firstname = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_firstname)) {
         newErrors.user_firstname = '*Name should only contain letters and spaces.';
      }

      if (!newData.user_emailaddress.trim()) {
         newErrors.user_emailaddress = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_emailaddress)) {
         newErrors.user_emailaddress = 'Enter a valid email address.';
      }

      // if (newData.user_contact_us && !/^\d{10}$/.test(newData.user_contact_us)) {
      //    newErrors.user_contact_us = 'Enter a valid 10-digit contact number.';
      // }

      if (!newData.user_contact_us.trim()) {
         newErrors.user_contact_us = '*number is required.';
       } else if (!/^\d{10}$/.test(newData.user_contact_us)) {
         newErrors.user_contact_us = 'Enter a valid 10-digit contact number.';
       }

      if (!newData.user_message) {
         newErrors.user_message = 'this field is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };

   const formPutPartenshipdeed = (e) => {
      e.preventDefault();
      if (validateForm()) {
         console.log("Button clicked!", newData);
         PartenerSheepDeedService.contactForm(newData)
            .then((data) => {

               alert("Form submitted successfully!");
               console.log(data);

               setNewData({
                  user_firstname: '',
         
                  user_emailaddress: '',
                  user_contact_us: '',
                  user_message: '',
               });

            })
            .catch((error) => console.log(error));
      }
   
   };




   return (
      <div >


         <div className="space60"></div>

         <div className="hero-area10 hero-section-banner">
            <div className="container">
               <div className="space80"></div>
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="space50"></div>
                        <h1 data-aos="fade-right">One Stop Solution for</h1>
                        <h1 className="type-text" data-aos="fade-right" id="typing-heading"><span id="typing-effect"></span></h1>
                        <p data-aos="fade-right" className="text-white">Manage and Scale Your Business with Expert Legal Assistance.</p>
                        <div className="space30"></div>
                        <div className="btn-group" data-aos="fade-right">
                           <Link to="/contactus" className="theme-btn-3">
                              Schedule A Call <span><i className="fa-solid fa-arrow-right"></i></span>
                           </Link>

                        </div>
                        <div className="space80"></div>
                        <div className="couter-all ">
                           {/* <div className="row">
                              <div className="col-sm-4 col-md-4 col-4">
                                 <div className="counter10-counter-box counter-line">
                                    <h2><span className="counter">90</span>k</h2>
                                    <p>Happy Client</p>
                                 </div>
                              </div>
                              <div className="col-sm-4 col-md-4 col-4">
                                 <div className="counter10-counter-box counter-line">
                                    <h2><span className="counter">650</span>+</h2>
                                    <p>Solved Case</p>
                                 </div>
                              </div>
                              <div className="col-sm-4 col-md-4 col-4">
                                 <div className="counter10-counter-box dis ">
                                    <h2><span className="counter">85</span>+</h2>
                                    <p>Work Together</p>
                                 </div>
                              </div>
                           </div> */}
                              <div className="home4-counters-all home-counter">
      <div className="row">
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-01.png"
                alt="Experience"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <p className="font-f-5 font-32 line-height-32 weight-600 color4 home-counter-heading">
                20 Years
              </p>
              <p className="font-f-5 font-16  p-size line-height-16 color-p-4 weight-400">
                Of Experience
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-02.png"
                alt="Cases Solved"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <p className="font-f-5 font-32 line-height-32 weight-600 color4 home-counter-heading">
                <CountUp end={500} duration={3} separator="," />
                +
              </p>
              <p className="font-f-5 p-size font-16 line-height-16 color-p-4 weight-400">
              Work Together
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box hide">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-03.png"
                alt="Awards Gained"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <p className="font-f-5 font-32 line-height-32 weight-600 color4 home-counter-heading">
                <CountUp end={5} duration={6} />
                +
              </p>
              <p className="font-f-5 p-size font-16 line-height-16 color-p-4 weight-400">
                Awards Gained
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-04.png"
                alt="Trusted Clients"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <p className="font-f-5 font-32 line-height-32 weight-600 color4 home-counter-heading">
                <CountUp end={250} duration={3} separator="," />
                K+
              </p>
              <p className="font-f-5 p-size font-16 line-height-16 color-p-4 weight-400">
              Happy Clients

              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-2 legal-white-box">
          <div className="home4-single-counter">
            <div className="home4-single-img">
              <img
                src="assets/img/icons/partnership-deed-05.png"
                alt="Queries Solved"
              />
            </div>
            <div className="home4-counter-hadding hadding5">
              <p className="font-f-5 font-32 line-height-32 weight-600 color4 home-counter-heading">
                <CountUp end={500} duration={3} separator="," />
                K
              </p>
              <p className="font-f-5 p-size font-16 line-height-16 color-p-4 weight-400">
              Cases & Queries Solved

              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
                        </div>
                 
                     </div>
                  </div>
                  <div className="col-lg-4 ">
                     <div className="contact3-form-all" data-aos="zoom-out" data-aos-duration="900">
                        <div className="hadding6 text-center">
                           <div className="space10"></div>
                           <p data-aos="fade-right" className="contact-para">Resolve your doubts <br/> with the help of</p>



                           <div className="container">
                              <div className="row">
                                 <div className="v-slider-frame ">
                                    <ul className="v-slides" ref={listRef}>
                                       <li className="v-slide">Tax Consultant</li>
                                       <li className="v-slide">Lawyer</li>
                                       <li className="v-slide">Chartered Accountant</li>
                                       <li className="v-slide">Company Secretary</li>
                                       <li className="v-slide">Legal Consultant</li>

                                    </ul>
                                 </div>
                              </div>
                           </div>

                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Name<span className="red">*</span></label> {errors.user_firstname && <p className="error-text">{errors.user_firstname}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_firstname} onChange={(e) => setNewData({ ...newData, user_firstname: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Email Address<span className="red">*</span></label>  {errors.user_emailaddress && <p className="error-text">{errors.user_emailaddress}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_emailaddress} onChange={(e) => setNewData({ ...newData, user_emailaddress: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Contact Number<span className="red">*</span></label>{errors.user_contact_us && <p className="error-text">{errors.user_contact_us}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact_us} onChange={(e) => setNewData({ ...newData, user_contact_us: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                       <label htmlFor="" className="dropdown-text">Related To <span className="red">*</span></label>{errors.user_message && <p className="error-text">{errors.user_message}</p>}
                                       <div className="niceSelect">
                                          <select className="wide" onChange={(e) => setNewData({ ...newData, user_message: e.target.value })} value={newData.user_message}>
                                             <option className="formop" data-display="Related to">Related to</option>
                                             <option value="Lawyer">Lawyer</option>
                                             <option value="Chartered Accountant">Chartered Accountant</option>
                                             <option value="Company Secretary">Company Secretary</option>
                                             <option value="Not sure">Not sure</option>
                                          </select>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2" >
                                 <a className="theme-btn-3" href="#" onClick={formPutPartenshipdeed}>GET CONSULTANCY <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
                  <div className="space90"></div>
               </div>
            </div>
         </div>




         <div className="about8 sp2 ledal-padd-common  bg-aliceblue ">
            <div className="container">
               <div className="row align-items-center">
                  <div className="col-lg-12 m-auto text-center">
                     <div className="headding8">
                        <span className="span" data-aos="fade-left"><img src="assets/img/icons/headding8-span.svg" alt="" /> Services</span>
                        <div className="space20"></div>
                        <h2 data-aos="fade-left" data-aos-duration="800" className="text-center">Our Comprehensive Legal Services</h2>
                        <div className="space16"></div>
                        <p data-aos="fade-left" data-aos-duration="1000">Simplifying A Wide Range of Legal Processes for Businesses and Individuals</p>
                        <div className="space30"></div>
                        <div className="row justify-content-center">
                           <div className="col-md-4 col-lg-3 col-6" data-aos="fade-up">
                              <Link to="/itrfiling">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-21">
                                       <img src="assets/img/icons/service-4.png" alt="" />
                                    </div>
                                    <h3>ITR Filing</h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6" data-aos="fade-up">
                              <Link to="/gstreturnfiling">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-18">
                                       <img src="assets/img/icons/service-3.png" alt="" />
                                    </div>
                                    <h3>GST Return Filing Online
                                    </h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6">
                              <Link to="/tdsreturnfiling">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-16">
                                       <img src="assets/img/icons/service-5.png" alt="" />
                                    </div>
                                    <h3>TDS Return Filing</h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6">
                              <Link to="/gstregistration">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-21">
                                       <img src="assets/img/icons/Online-GST-Registration.png" alt="" />
                                    </div>
                                    <h3>GST Registration</h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6">
                              <Link to="/trademarkregistration">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-18">
                                       <img src="assets/img/icons/Trademark-Registration-Service.png" alt="" />
                                    </div>
                                    <h3>Trademark Registration</h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6" data-aos="fade-up">
                              <Link to="/foodlicence">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-23">
                                       <img src="assets/img/icons/service-7.png" alt="" />
                                    </div>
                                    <h3>FSSAI Registration </h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6">
                              <Link to="/gumastalicense">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-15">
                                       <img src="assets/img/icons/Gumasta-License.png" alt="" />
                                    </div>
                                    <h3>Shop Act License (Gumasta)</h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6">
                              <Link to="/importexportlicenseiec">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-16">
                                       <img src="assets/img/icons/IEC-Registration-Online---Apply-for-Import-Export-License.png" alt="" />
                                    </div>
                                    <h3>Import Export License (IEC)
                                    </h3>
                                 </div>
                              </Link>
                           </div>
                           <div className="col-md-4 col-lg-3 col-6 hide">
                              <Link to="/msmeregistration">
                                 <div className="single-service text-center">
                                    <div className="service-icon bg-19 msme">
                                       <img src="assets/img/icons/MSME-Registration-Online.png" alt="" />
                                    </div>
                                    <h3>MSME Registration</h3>
                                 </div>
                              </Link>
                           </div>










                        </div>
                     </div>
                     <div className="btn-group-2">
                        <Link to="/services" className="theme-btn-3">
                           All Categories <span><i className="fa-solid fa-arrow-right"></i></span>
                        </Link>

                     </div>
                     <div className="space10"></div>
                  </div>
               </div>
            </div>
         </div>


         <div className="about-area section-padding sb-color">
            <div className="container">
               <div className="row align-items-center">
                  <div className="col-lg-6 d-none d-lg-block">
                     <div className="mr50">
                        <div className="heading2 no-margin-heading">
                           <small data-aos="fade-right" className="heading-top"><img
                              src="assets/img/icons/hands.svg" alt="" />Simplifying Legal Processes</small>
                           <h2 data-aos="fade-right" className="text-white text-black">Why Choose Dm2Legal?</h2>
                           <p data-aos="fade-right" className=" pd-text text-white text-black">Dm2Legal is your trusted partner for preparing legal documents, handling registrations, and ensuring seamless compliance. Our team of experienced professionals guarantees timely and accurate filings. For added convenience, we provide a mobile app and an intuitive dashboard, allowing you to manage services and documents effortlessly from anywhere. With more than a decade of industry experience, we offer the reliability and expertise you can depend on. As the saying goes, "The best preparation for tomorrow is doing your best today," and that’s exactly what we strive to deliver.
                           </p>
                           <div className="space50"></div>
                           <div className="button-group" data-aos="fade-right">
                              <Link to="/aboutcompany" className="theme-btn-lite theme-btn-3">
                                 More About Us <span><i className="fa-solid fa-arrow-right"></i></span>

                              </Link>

                          

                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="counter2 ml50 position-relative">
                        <div className="row">
                           <div className="col-md-6">
                              <div className="single-counter" data-aos="zoom-out" >
                                 <div className="conter-icon">
                                    <img src="assets/img/icons/counter21a.png" alt="" />
                                 </div>
                                 <h2><span className="up-counter">5</span>M+</h2>
                                 <p>Tax filed</p>
                              </div>
                              <div className="single-counter" data-aos="zoom-out">
                                 <div className="conter-icon">
                                    <img src="assets/img/icons/counter22a.png" alt="" />
                                 </div>
                                 <h2><span className="up-counter">250</span>K+</h2>
                                 <p>Trusted Clients</p>
                              </div>
                           </div>
                           <div className="col-md-6">
                              <div className="single-counter mt-5" data-aos="zoom-out" >
                                 <div className="conter-icon">
                                    <img src="assets/img/icons/counter23a.png" alt="" />
                                 </div>
                                 <h2><span className="up-counter">1</span>M+</h2>
                                 <p>Invoices Uploaded</p>
                              </div>
                              <div className="single-counter" data-aos="zoom-out" >
                                 <div className="conter-icon">
                                    <img src="assets/img/icons/counter24a.png" alt="" />
                                 </div>
                                 <h2><span className="up-counter">500</span>K</h2>
                                 <p>Queries Solved</p>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6 d-lg-none">
                     <div className="mr50">
                        <div className="heading2 no-margin-heading">
                           <small className="heading-top"><img src="assets/img/icons/hands.svg" alt="" />Simplifying Legal Processes</small>
                           <h2>Why Choose Dm2Legal?</h2>
                           <p className="pd-text"> Dm2Legal is your go-to partner for preparing legal documents, registrations,
                              and compliance with confidence and ease. Our team of seasoned experts ensures that your filings are always timely and precise.
                              To make things even more convenient, we offer a mobile app and user-friendly dashboard, allowing you to manage services and documents seamlessly from anywhere.
                              With over a decade of industry experience, we deliver the reliability and expertise you can count on.
                              As they say, 'The best preparation for tomorrow is doing your best today,' and that’s exactly what we promise to deliver.
                           </p>
                           <div className="space50"></div>
                           <a className="theme-btn-3" href="about-1.html">More About Us <span><i className="fa-solid fa-arrow-right"></i></span></a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="service7 sp2">
            <div className="container">
               <div className="row">
                  <div className="col-lg-10 m-auto text-center">
                     <div className="hadding7">
                        <span className="span" data-aos="fade-up" ><img src="assets/img/icons/money.png" alt="" /> What is Dm2Legal?
                        </span>
                        <div className="space20"></div>
                        <h2 data-aos="fade-up" className="text-center" >What is Dm2Legal?</h2>
                        <div className="space20"></div>
                        <p className="pd-text"> Dm2Legal is your trusted online legal advisor, simplifying complex legal processes for individuals and businesses alike. As a comprehensive provider of legal solutions, we address all legal queries, ensuring clarity and ease for everyone. Founded with the mission to streamline legal issues for every citizen, Dm2Legal has become a name synonymous with trust and reliability. Our services are specifically designed to help startups and businesses simplify registrations and legal management. What started as an initiative to reduce the time businesses spend on legal formalities has evolved into a platform that clients love, achieving a 95% client retention rate. Today, we are a growing team of over 100 professionals, including Chartered Accountants, Lawyers, Legal Advisors, and Accounting Managers.
                           Our value-driven approach has helped us reach significant milestones, and with our recent move to digital platforms, we’ve made our services accessible on mobile devices, desktops, and PCs—bringing the best-in-className technology to our clients' fingertips. At Dm2Legal, trust and transparency are at the core of our values, motivating us to exceed expectations and ensure client satisfaction remains our top priority.
                        </p>
                     </div>
                  </div>
               </div>
               <div className="space60"></div>


               <ServicesTabs />

            </div>
         </div>


         <Testimonials />

         <div className="cta10" >
            <div className="container">
               <div className="row">
                  <div className="col-lg-8 m-auto text-center">
                     <div className="headding">
                        <h2>Streamline Your Tax Filing Process</h2>
                        <p >Get started with income tax e-filing today, guided by our expert tax professionals for a smooth and hassle-free experience.</p>
                        <Link to="/contactus" className="theme-btn-3">
                           Schedule A Call <span><i className="fa-solid fa-arrow-right"></i></span>
                        </Link>

                     </div>
                  </div>
               </div>
            </div>
         </div>



         <WhatsAppScrollButton />

         <Footer />

         <CircularScrollProgress />


      </div>
   );
}

export default Content;
